import { sectionedPanelStyle } from '../CampaignStyles';

export const summaryPanelStyle = {
    ...sectionedPanelStyle,
    paddingBottom: 25.5
};

export const deliveryPanelStyle = {
    ...sectionedPanelStyle,
    marginBottom: 25.5
};

export const goalTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 21,
    fontWeight: 500
};

export const createQuoteButtonStyle = {
    boxSizing: 'border-box',
    height: 40,
    width: 130,
    border: '2px solid #FD9A00',
    borderRadius: 5,
    backgroundColor: '#FAA800',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 'bold',
    zIndex: 102
};

export const disabledCreateQuoteButtonStyle = {
    ...createQuoteButtonStyle,
    border: '1px solid #A6A6A6',
    backgroundColor: '#CCCCCC'
};

export const editButtonStyle = {
    boxSizing: 'border-box',
    height: 40,
    width: 121,
    border: '1px solid #FFB50C',
    borderRadius: 5,
    backgroundColor: '#FDF1D6',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 'bold'
};

export const disabledEditButtonStyle = {
    ...editButtonStyle,
    border: '1px solid #A6A6A6',
    backgroundColor: '#CCCCCC'
};

export const planButtonStyle = {
    boxSizing: 'border-box',
    height: 40,
    width: 122,
    fontSize: 15,
    fontWeight: 'bold',
    zIndex: 102
};

export const disabledPlanButtonStyle = {
    ...planButtonStyle,
    border: '1px solid #A6A6A6',
    backgroundColor: '#CCCCCC'
};

export const labelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: 12,
    color: '#414141',
    marginBottom: 5
};

export const inputStyle = {
    boxSizing: 'border-box',
    width: 272,
    height: 40,
    outline: 'none',
    padding: '0 12px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600,
    color: '#414141'
};

export const reservationBoxStyle = {
    boxSizing: 'border-box',
    borderRadius: 10,
    height: 65,
    width: 398,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'space-between'
};

export const airtimeReservationTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const summaryTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500
};

export const summaryHeadingStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold'
};

export const impactsDigitStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'bold'
};

export const reservedTextStyle = (textColor) => {
    return {
        color: textColor,
        fontFamily: 'Roboto',
        fontSize: 18,
        fontWeight: 500
    };
};

export const reservedTimeStyle = (textColor) => {
    return {
        color: textColor,
        fontFamily: 'Roboto',
        fontSize: 18,
        fontWeight: 500
    };
};

export const summaryHeadCellStyle = {
    boxSizing: 'border-box',
    height: 32,
    border: '1px solid #D7D7D7',
    backgroundColor: '#F7F7F7',
    width: '14.28%'
};

export const summaryBaseCellStyle = {
    boxSizing: 'border-box',
    height: 25,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF',
    paddingRight: 16
};

export const summaryTargetCellStyle = {
    boxSizing: 'border-box',
    height: 25,
    border: '1px solid #D7D7D7',
    backgroundColor: '#F7F7F7',
    paddingRight: 16
};

export const chartDateStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 500
};

export const deliveryTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500
};

export const deliveryTableNameStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 'bold'
};

export const deliveryTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    paddingLeft: 6
};

export const deliveryNameCellStyle = {
    boxSizing: 'border-box',
    height: 33,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF'
};

export const deliveryFirstHeadCellStyle = {
    boxSizing: 'border-box',
    height: 40,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF',
    paddingLeft: 6
};

export const deliveryHeadCellStyle = {
    boxSizing: 'border-box',
    height: 32,
    border: '1px solid #D7D7D7',
    backgroundColor: '#F7F7F7',
    width: '5.28%'
};

export const deliverySpotsHeadCellStyle = {
    boxSizing: 'border-box',
    height: 63,
    border: '1px solid #D7D7D7',
    backgroundColor: '#F7F7F7',
    width: '5.28%'
};

export const deliveryMainCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 35,
        border: '1px solid #D7D7D7',
        backgroundColor: i % 2 === 0 ? '#FFFFFF' : '#F7F7F7',
        paddingRight: 8
    };
};

export const deliveryTotalCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 35,
        border: '1px solid #D7D7D7',
        backgroundColor: i % 2 === 0 ? '#EBEBEB' : '#F7F7F7',
        paddingRight: 8
    };
};

export const deliverySumCellStyle = {
    boxSizing: 'border-box',
    height: 35,
    border: '1px solid #D7D7D7',
    backgroundColor: '#EBEBEB',
    paddingRight: 8
};

export const planManagerContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 10,
    marginLeft: 25
};

export const campaignGoalTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 21,
    fontWeight: 500
};

export const planSummaryContainerStyle = {
    width: 1788,
    marginTop: 37,
    marginLeft: 22
};

export const deliveryHeadingsContainerStyle = {
    width: 1788,
    display: 'flex'
};

export const planDeliveryContainerStyle = {
    margin: 25,
    display: 'grid',
    gap: 25,
    gridTemplateColumns: 'auto auto'
};

export const deliverySpotsContainerStyle = {
    minHeight: 200
};

export const deliveryImpactsContainerStyle = {
    minHeight: 200
};

export const summaryTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed'
};

export const deliveryTitleBoxStyle = {
    boxSizing: 'border-box',
    height: 33,
    width: 783,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

export const spotsTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed',
    pageBreakInside: 'avoid'
};

export const impactsTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed',
    pageBreakAfter: 'always',
    pageBreakBefore: 'always',
    pageBreakInside: 'avoid'
};

export const goalsContainerStyle = {
    position: 'absolute',
    marginTop: 43,
    marginLeft: 267,
    zIndex: 101
};

export const goalsMenuStyle = {
    boxSizing: 'border-box',
    height: 285,
    width: 171,
    marginLeft: -141,
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    backgroundColor: '#FFFFFF',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)'
};

export const goalOptionStyle = {
    height: 26,
    cursor: 'pointer',
    paddingLeft: 11,
    paddingTop: 7,
    width: 158
};

export const goalCurrentOptionStyle = {
    height: 26,
    cursor: 'default',
    paddingLeft: 11,
    paddingTop: 7,
    width: 158
};

export const goalTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500
};

export const goalCurrentTextStyle = {
    color: '#B6B6B6',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500
};

export const progressBoxStyle = {
    boxSizing: 'border-box',
    height: 147,
    width: 391,
    border: '1px solid #B3B3B3',
    borderRadius: 5,
    backgroundColor: '#FFFFFF'
};

export const waitTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 18,
    fontWeight: 'bold'
};

export const progressContainerStyle = {
    boxSizing: 'border-box',
    height: 30,
    width: 363,
    border: '2px solid #FD9A00',
    borderRadius: 5
};

export const progressFillStyle = (percent) => {
    return {
        height: 22,
        width: 355 * percent,
        borderRadius: '2px 0 0 2px',
        backgroundColor: '#FAA800'
    };
};

export const percentTextStyle = {
    color: '#FD9A00',
    fontFamily: 'Roboto',
    fontSize: 18,
    fontWeight: 'bold'
};

export const performanceToDateStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const disabledStyle = {
    boxSizing: 'border-box',
    border: '1px solid #D7D7D7',
    backgroundColor: '#F7F7F7'
};